<script>
  import { DataTable, TimePicker } from "carbon-components-svelte";
  import ActionButtons from "./ActionButtons.svelte";
  import { PLUS_ICON } from "@utils/icons.js";
  import { TextInput, Button } from "paxray-components-svelte";

  export let subActivitiesByRow = [];
  export let headers = [];
  export let handleDelete = () => {};
  export let handleEdit = () => {};
  export let handleAdd = () => {};
  export let handleUpdateTime = () => {};
  export let handleDateChange = () => {};
  export let deletedSubActivityRows = [];
  export let deletedActivityRows = [];

  $: console.log("subActivitiesByRow", subActivitiesByRow);
  let valueToEdit = { row: -1, key: "" };
  let datePicker = "";

  const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;

  function isDeleted(id, type) {
    if (type === "activity") {
      return deletedActivityRows.includes(id);
    } else if (type === "subActivity") {
      return deletedSubActivityRows.includes(id);
    }
  }
</script>

<DataTable
  size="compact"
  rows={subActivitiesByRow}
  {headers}
  sortable
  class="custom-table"
>
  <svelte:fragment slot="cell" let:row let:cell>
    {#if cell.key === "activityActions"}
      <ActionButtons
        small
        handleDelete={() => handleDelete(row.id, "subActivity")}
        handleEdit={() => handleEdit(row.id, "subActivity")}
        handleRestart={() => handleDelete(row.id, "subActivity")}
        restart={isDeleted(row.id, "subActivity")}
      />
    {:else if cell.key === "activity"}
      {#if row.subActivityName === ""}
        {#if valueToEdit.row !== row.id || valueToEdit.key !== cell.key}
          <Button
            kind="primary"
            smallRounded={true}
            icon={PLUS_ICON}
            iconLeft={true}
            text={cell.key}
            on:click={() => (valueToEdit = { row: row.id, key: cell.key })}
            disabled={isDeleted(row.id, "subActivity")}
          />
        {:else if valueToEdit.row === row.id && valueToEdit.key === cell.key && !isDeleted(row.id, "subActivity")}
          <TextInput
            id={cell.key}
            placeholder={cell.value}
            handleChange={(e) => handleAdd(e, row.id, "subActivityName")}
            on:change={(e) => handleAdd(e, row.id, "subActivityName")}
            on:focusout={() => (valueToEdit = { row: -1, key: "" })}
          />
        {/if}
      {:else}
        <span
          class:deleted-cell={isDeleted(row.id, "subActivity") ||
            isDeleted(row.activityId, "activity")}
        >
          {row.subActivityName}
        </span>
      {/if}
    {:else if cell.key === "activityExpense"}
      <span
        class:deleted-cell={isDeleted(row.id, "subActivity") ||
          isDeleted(row.activityId, "activity")}
      >
        {row.subActivityExpense || "-"}
      </span>
    {:else if cell.key === "activityStart"}
      {#if row.subActivityStart === ""}
        <TimePicker
          placeholder="hh:mm"
          label="Beginn"
          size="sm"
          light
          value={row.subActivityStart}
          on:change={(e) => handleUpdateTime(e, row.id, "subActivityStart")}
          pattern={timePattern}
          invalid={row.subActivityStart.match(timePattern) &&
            row.subActivityStart !== "hh:mm"}
        />
      {:else}
        <span
          class:deleted-cell={isDeleted(row.id, "subActivity") ||
            isDeleted(row.activityId, "activity")}
        >
          {row.subActivityStart}
        </span>
      {/if}
    {:else if cell.key === "activityEnd"}
      {#if row.subActivityEnd === ""}
        <TimePicker
          placeholder="hh:mm"
          label="Ende"
          size="sm"
          light
          value={row.subActivityEnd}
          on:change={(e) => handleUpdateTime(e, row.id, "subActivityEnd")}
          pattern={timePattern}
          invalid={row.subActivityEnd.match(timePattern) &&
            row.subActivityEnd !== "hh:mm"}
        />
      {:else}
        <span
          class:deleted-cell={isDeleted(row.id, "subActivity") ||
            isDeleted(row.activityId, "activity")}
        >
          {row.subActivityEnd}
        </span>
      {/if}
    {:else if cell.key === "activityDate"}
      {#if row.subActivityDate === ""}
        {#if datePicker !== row.id}
          <Button
            kind="primary"
            smallRounded={true}
            icon={PLUS_ICON}
            iconLeft={true}
            text="datum"
            on:click={() => (datePicker = row.id)}
            disabled={isDeleted(row.id, "subActivity")}
          />
        {:else if datePicker === row.id && !isDeleted(row.id, "subActivity")}
          <TextInput
            date={true}
            id="datum"
            placeholder={row.subActivityDate}
            handleDateChange={(e) => handleDateChange(e, row.id)}
            value={row.subActivityDate}
            on:change={(e) => handleDateChange(e, row.id)}
          />
        {/if}
      {:else}
        <span
          class:deleted-cell={isDeleted(row.id, "subActivity") ||
            isDeleted(row.activityId, "activity")}
        >
          {row.subActivityDate}
        </span>
      {/if}
    {/if}
  </svelte:fragment>
</DataTable>

<style>
  .deleted-cell {
    text-decoration: line-through;
    opacity: 0.5;
  }
</style>
